<template>
  <div>
    <v-container fluid class="pa-0">
      <v-card class="v-card--material pa-3 ma-2 rounded-lg" elevation="2">
        <v-row no-gutters>
          <v-col cols="12" md="6" lg="4" sm="6" xs="12" class="my-0 py-0">
            <div class="d-flex grow flex-wrap">
              <div
                class="font-weight-regular headline text-decoration-underline text-capitalize"
              >
                {{ kit ? kit.name : '-' }} Products Mapping
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="6" lg="8" sm="6" xs="12">
            <v-card-text
              class="pt-0 pr-1"
              :class="{
                'd-block py-3': $vuetify.breakpoint.xs,
                'd-flex align-center': $vuetify.breakpoint.smAndUp
              }"
            >
              <v-btn
                small
                class="ml-auto mb-2"
                elevation="1"
                @click="uploadProduct()"
                color="accent"
              >
                <v-icon left>mdi-plus</v-icon>
                Add
              </v-btn>
            </v-card-text>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="3" lg="3" sm="3" xs="12">
            <v-autocomplete
              name="kittype"
              v-model="kit"
              :items="constantKit"
              required
              key="id"
              @change="setkitType"
              return-object
              item-text="name"
            >
              <template v-slot:label>
                Kit Type <span class="error--text">*</span>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" md="3" lg="3" sm="3" xs="12">
            <v-autocomplete
              v-model="selectedMappingObj.classID"
              :items="classes"
              item-text="name"
              item-value="id"
              key="id"
              required
            >
              <template v-slot:label>
                {{
                  kitTypes[0]
                    ? kitTypes[0].franchiseeModel
                      ? kitTypes[0].studentClass
                        ? 'Kits'
                        : 'Center Type'
                      : 'Class Name'
                    : 'Kits'
                }}
                <span class="error--text">*</span>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col class="has-text-right" cols="12" md="3" sm="3" xs="12">
            <v-autocomplete
              key="id"
              :items="academicYears"
              v-model="academicYearID"
              item-text="academicYear"
              item-value="id"
            >
              <template v-slot:label> Academic Year </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" md="3" lg="3" sm="3" xs="12">
            <div class="d-flex caption">
              <v-btn
                v-if="$vuetify.breakpoint.smAndUp"
                small
                id="apply"
                color="success"
                elevation="1"
                type="submit"
                class="ml-2 mt-5"
                @click="getKitListing"
              >
                <v-icon left size="18"> mdi-text-box-check-outline </v-icon>
                Apply
              </v-btn>
              <v-btn
                v-if="$vuetify.breakpoint.smAndUp"
                small
                elevation="1"
                type="reset"
                @click="resetAll()"
                class="ml-2 mt-5"
              >
                <v-icon left size="18"> mdi-restart</v-icon> Reset
              </v-btn>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="12" lg="12" sm="12" xs="12">
            <v-data-table
              :search="search"
              item-key="id"
              :headers="headers"
              :items="wowKitData"
            >
              <template v-slot:item.isActive="{ item }">
                <span class="has-text-success" v-if="item.isActive"
                  >Active</span
                >
                <span class="has-text-danger" v-else>In Active</span>
              </template>
              <template v-slot:item.status="{ item }">
                <span>{{ item.status }}</span>
                <v-btn
                  v-if="item.status === 'REJECT'"
                  color="error"
                  text
                  @click="showReasonPrompt(item.reason)"
                >
                  View Reason
                </v-btn>
              </template>

              <template v-slot:item.actions="{ item }">
                <v-btn
                  class="ml-1 mb-1"
                  outlined
                  small
                  dense
                  color="primary"
                  elevation="0"
                  @click="viewKitData(item.id)"
                >
                  View
                </v-btn>
                <v-btn
                  v-if="item.status === 'PENDING'"
                  class="ml-1 mb-1"
                  outlined
                  small
                  dense
                  color="primary"
                  elevation="0"
                  :disabled="item.productCount <= 0"
                  @click="editUploadKitMapping(item.id, item.productCount)"
                >
                  Edit
                </v-btn>
                <v-btn
                  v-if="item.status === 'PENDING' && kitApproval"
                  class="ml-1 mb-1"
                  outlined
                  :disabled="item.productCount <= 0"
                  small
                  dense
                  color="success"
                  elevation="0"
                  @click="approvedByChecker('ch1', item.id)"
                >
                  Approve CH 1
                </v-btn>
                <v-btn
                  v-if="item.status === 'CH1_APPROVED' && kitApproval"
                  class="ml-1 mb-1"
                  outlined
                  small
                  dense
                  color="success"
                  elevation="0"
                  :disabled="
                    item.status === 'APPROVED' ||
                    item.status === 'REJECT' ||
                    item.productCount <= 0
                  "
                  @click="approvedByChecker('ch2', item.id)"
                >
                  Approve CH 2
                </v-btn>
                <v-btn
                  class="ml-1 mb-1"
                  v-if="
                    item.status !== 'REJECT' &&
                    item.status !== 'APPROVED' &&
                    kitApproval
                  "
                  outlined
                  :disabled="item.productCount <= 0"
                  small
                  dense
                  color="error"
                  elevation="0"
                  @click="rejectKit(item.id)"
                >
                  Reject
                </v-btn>
                <v-btn
                  class="ml-1 mb-1"
                  outlined
                  v-if="!item.isActive"
                  small
                  id="apply"
                  color="success"
                  elevation="1"
                  type="submit"
                  @click="restoreStatus(item)"
                >
                  <v-icon left size="18"> mdi-text-box-check-outline </v-icon>
                  Active
                </v-btn>
                <v-btn
                  class="ml-1 mb-1"
                  outlined
                  v-else
                  small
                  id="apply"
                  color="error"
                  elevation="1"
                  type="submit"
                  @click="restoreStatus(item)"
                >
                  <v-icon left size="18"> mdi-delete </v-icon> DeActive
                </v-btn>
              <v-btn
              v-if="item.kitName"
                class="ml-1 mb-1"
                :color="item.isAssigned ? 'pink' : 'primary'"
                :disabled=" !item.isActive || item.status !== 'APPROVED'"
                small
                elevation="1"
                @click="openAssignDialog(item)"
              >
                <template v-if="item.isAssigned">
                  Assigned
                </template>
                <template v-else>
                  Assign
                </template>
              </v-btn>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card>
      <!--Add Reject Checker Dialogue-->
      <v-dialog v-model="rejectCheckerFlag" persistent max-width="500">
        <v-card>
          <v-toolbar dark color="#5d58ef" elevation="0">
            <v-toolbar-title>Reson to reject</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="rejectCheckerFlag = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text class="px-2">
            <v-container fluid>
              <v-row>
                <v-col cols="12" md="12" xs="12" lg="12">
                  <v-textarea
                    v-model="rejectCheckerReason"
                    variant="filled"
                    auto-grow
                    label="Please specify the reason to reject the kit."
                    rows="2"
                    row-height="20"
                  ></v-textarea>
                </v-col>
                <v-col class="pa-1" cols="12" md="12" lg="12" xs="12" sm="12">
                  <v-card-actions class="pa-0 justify-end">
                    <v-btn color="#5d58ef" outlined @click="rejectByChecker">
                      Reject the kit
                    </v-btn>
                  </v-card-actions>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!--Add dialog to view detail-->
      <v-dialog v-model="previewKitData" persistent max-width="900" fullscreen>
        <v-card>
          <v-toolbar dark color="#5d58ef" elevation="0">
            <v-toolbar-title>Kit Configuration Data</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="previewKitData = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text class="px-2">
            <v-container fluid>
              <v-row>
                <v-col cls="12" md="4" lg="4" sm="4" xs="12">
                  <div class="d-flex justify-space-between caption">
                    <div>
                      <div class="grey--text text-subtitle-2 mb-1">
                        Kit Type
                      </div>
                      <div
                        class="text-button mb-1"
                        v-text="kitSetMapData.kitName"
                      ></div>
                    </div>
                  </div>
                </v-col>
                <v-col cls="12" md="4" lg="4" sm="4" xs="12">
                  <div class="d-flex justify-space-between caption">
                    <div>
                      <div class="grey--text text-subtitle-2 mb-1">Class</div>
                      <div
                        class="text-button mb-1"
                        v-text="kitSetMapData.class"
                      ></div>
                    </div>
                  </div>
                </v-col>
                <v-col cls="12" md="4" lg="4" sm="4" xs="12">
                  <div class="d-flex justify-space-between caption">
                    <div>
                      <div class="grey--text text-subtitle-2 mb-1">
                        Set Name
                      </div>
                      <div
                        class="text-button mb-1"
                        v-text="kitSetMapData.setName"
                      ></div>
                    </div>
                  </div>
                </v-col>
                <v-col class="pa-1" cols="12" md="12" lg="12" xs="12" sm="12">
                  <v-card-actions class="pa-0 justify-end">
                    <v-btn
                      v-if="!kitSetMapData.status"
                      color="#5d58ef"
                      outlined
                      @click="addKitDialogFlag = true"
                    >
                      Add Kit
                    </v-btn>
                  </v-card-actions>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="pa-1" cols="12" md="12" lg="12" sm="12" xs="12">
                  <v-data-table
                    disable-pagination
                    :hide-default-footer="true"
                    :headers="singleListHeader"
                    :items="kitSetProductData"
                  ></v-data-table>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!--Form Dialogue-->
      <v-row justify="center">
        <v-dialog v-model="addKitDialogFlag" persistent max-width="600px">
          <v-card>
            <v-card-title>
              <span class="text-h6">Add Kit Details</span>
            </v-card-title>
            <v-divider class="my-1"></v-divider>
            <v-card-text>
              <v-container fluid>
                <v-row>
                  <v-col
                    class="pa-1 my-2"
                    cols="12"
                    md="6"
                    lg="6"
                    sm="6"
                    xs="12"
                  >
                    <label>FCID <span class="error--text">*</span></label>
                    <v-text-field
                      type="number"
                      placeholder="FCID"
                      v-model="dialogue.fcid"
                      hide-details="true"
                      single-line
                      dense
                    />
                  </v-col>
                  <v-col
                    class="pa-1 my-2"
                    cols="12"
                    md="6"
                    lg="6"
                    sm="12"
                    xs="12"
                  >
                    <label>Quantity <span class="error--text">*</span></label>
                    <v-text-field
                      type="number"
                      v-model="dialogue.quantity"
                      hide-details="true"
                      single-line
                      placeholder="Quantity"
                      dense
                    />
                  </v-col>
                  <v-col
                    class="pa-1 my-2"
                    cols="12"
                    md="6"
                    lg="6"
                    sm="12"
                    xs="12"
                  >
                    <label
                      >isMandatory <span class="error--text">*</span></label
                    >
                    <v-autocomplete
                      :class="{
                        'mr-0 my-1': $vuetify.breakpoint.xs,
                        'mr-5': $vuetify.breakpoint.smAndUp
                      }"
                      v-model="dialogue.isMandatory"
                      :items="isMandatory"
                      dense
                      single-line
                      hide-details="true"
                      :style="
                        $vuetify.breakpoint.xs ? 'width:150px' : 'width:auto;'
                      "
                    ></v-autocomplete>
                  </v-col>
                  <v-col
                    class="pa-1 my-2"
                    cols="12"
                    md="6"
                    lg="6"
                    sm="12"
                    xs="12"
                  >
                    <label>Alternate FCID 1</label>
                    <v-text-field
                      type="number"
                      v-model="dialogue.alterFCID1"
                      hide-details="true"
                      label="Alternate FCID 1"
                      single-line
                      dense
                    />
                  </v-col>
                  <v-col
                    class="pa-1 my-2"
                    cols="12"
                    md="6"
                    lg="6"
                    sm="12"
                    xs="12"
                  >
                    <label>Alternate FCID 2</label>
                    <v-text-field
                      type="number"
                      v-model="dialogue.alterFCID2"
                      hide-details="true"
                      placeholder="Alternate FCID 2"
                      single-line
                      dense
                    />
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeKitDialoguePopup">
                Close
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="addMoreKitData(kitSetMapData.id)"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    <v-dialog v-model="showAssignDialog" persistent max-width="500">
      <v-card>
        <v-toolbar flat color="#fff">
          <v-spacer></v-spacer>
          <v-btn icon @click="resetAssignDialog">
            <v-icon color="grey">mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-form ref="assignForm" lazy-validation>
            <v-row>
              <v-col cols="12">
                <v-autocomplete
                  placeholder="Select Zone"
                  name="sZone"
                  @change="onZoneSelect"
                  v-model="selectedSectionID"
                  required
                  item-text="zone"
                  item-value="zone"
                  :items="selectedZones"
                  key="id"
                  multiple
                  :search-input.sync="zoneSearch"
                  ref="zoneAutocomplete"
                />
              </v-col>
              <v-col cols="12">
               <v-checkbox
                  :disabled="centerList.length === 0"
                  v-model="allFranchiseeChecked"
                  label="All Franchisee"
                  @change="toggleAllFranchisee"
                />
                <v-autocomplete
                  multiple
                  v-model="franchiseeID"
                  :items="centerList"
                  item-text="companyName"
                  item-value="id"
                  placeholder="Select Franchisee"
                  :search-input.sync="franchiseeSearch"
                  @change="onFranchiseeSelect"
                  ref="franchiseeAutocomplete"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success" @click="assignSampleKit">Assign</v-btn>
          <v-btn @click="cancelAssign">Cancel</v-btn>
        </v-card-actions>
      </v-card>
     </v-dialog>
    </v-container>
  </div>
</template>
<script>
import constants from '@/utils/constants'
import _ from 'lodash'
import Utils from '@/utils'
export default {
  name: 'wowkitmapping',
  props: ['kitType'],
  data () {
    return {
      constantKit: _.filter(
        constants.KIT,
        (obj) => obj.isDisplayOnMapping === true
      ),
      data: [],
      columns: [],
      paginated: false,
      perPage: 10,
      checkedRows: [],
      total: 0,
      modelID: '',
      enableFilterModal: false,
      modelArr: [],
      kitTypes: [],
      classes: [],
      wowKitData: [],
      academicYears: [],
      academicYearID: '',
      selected: 'All',
      kit: {},
      selectedMappingObj: {
        KitID: 0,
        classID: ''
      },
      loadingComponent: null,
      search: '',
      headers: [
        { text: 'Kit Name', value: 'kitName', sortable: true, align: 'center' },
        { text: 'Year', value: 'year', sortable: true, align: 'center' },
        { text: 'Class', value: 'class', sortable: true, align: 'center' },
        { text: 'Set Name', value: 'setName', sortable: true, align: 'center' },
        { text: 'Status', value: 'status', sortable: true, align: 'center' },
        {
          text: 'isActive',
          value: 'isActive',
          sortable: true,
          align: 'center'
        },
        { text: 'Action', value: 'actions', align: 'left' }
      ],
      isPaginationApply: true,
      page: 1,
      totalPages: 0,
      totalItems: 0,
      pageSize: 10,
      pageSizes: [5, 10, 50, 100],
      isLoading: false,
      showRecord: null,
      previewKitData: false,
      singleListHeader: [
        { text: 'FCID', value: 'productID', sortable: true, align: 'center' },
        { text: 'altFCID1', value: 'altProductID1', align: 'center' },
        { text: 'altFCID2', value: 'altProductID2', align: 'center' },
        { text: 'Quantity', value: 'quantity', align: 'center' }
      ],
      isMandatory: [
        { text: 'Yes', value: 'Yes' },
        { text: 'No', value: 'No' }
      ],
      kitSetMapData: {
        id: '',
        kitName: '',
        class: '',
        setName: '',
        status: ''
      },
      kitSetProductData: [],
      dialogue: {
        fcid: '',
        quantity: '',
        isMandatory: 'No',
        alterFCID1: '',
        alterFCID2: ''
      },
      addKitDialogFlag: false,
      rejectCheckerFlag: false,
      rejectCheckerReason: '',
      rejectKitSetMapId: '',
      kitApproval: false,
      showAssignDialog: false,
      selectedSectionID: [],
      franchiseeID: [],
      selectedZones: [],
      centerList: [],
      assigningKitItem: null,
      zoneSearch: '',
      franchiseeSearch: '',
      allFranchiseeChecked: false
    }
  },
  created: async function () {
    await this.onStart()
    this.kitApproval = this.checkModuleAccess('kitApproval')
    this.getFranchisee()
    this.getZoneDetails()
  },
  watch: {
    kitType: function (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.onStart()
      }
    }
  },
  methods: {
    onStart: async function () {
      this.kit = _.find(this.constantKit, (item) =>
        _.isEqual(item.route, this.kitType)
      )
      if (!_.isEmpty(this.kit)) {
        this.selectedMappingObj.KitID = ''
        this.selectedMappingObj.classID = ''
        this.kitTypes = []
        await this.getKitType()
        await this.getAcademicYear()
        await this.getKitListing()
        await this.getClasses()
      } else {
        return this.$buefy.dialog.alert({
          message: 'Select valid kit',
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    dateFormat: function (i) {
      let j = i % 10
      let k = i % 100
      if (j === 1 && k !== 11) {
        return i + 'st'
      }
      if (j === 2 && k !== 12) {
        return i + 'nd'
      }
      if (j === 3 && k !== 13) {
        return i + 'rd'
      }
      return i + 'th'
    },
    setkitType: function () {
      console.log(this.kit)
      if (!_.isEmpty(this.kit)) {
        this.$router.push({
          name: 'listKitMapping',
          params: {
            kitType: this.kit.route,
            kitID: Number(this.selectedMappingObj.KitID)
          }
        })
      }
    },

    checkModuleAccess: function (moduleName) {
      return Utils.helper.checkAccessByModule(this.$route, moduleName)
    },
    getKitType: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        const response = await http.get(
          `${constants.API_URL}/api/kits?kitType=${this.kit.id}`
        )
        this.loadingComponent.close()
        if (response.data) {
          this.kitTypes = response.data.rows
        } else {
          this.kitTypes = []
        }
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('Error While fetching product id ', errorMessage)
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    getClasses: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        const studentclasses = await http.get(
          `${constants.API_URL}/api/students/class`
        )
        this.classes = studentclasses.data.rows

        this.classes.filter((item) => {
          item.category = item.category ? ' ( ' + item.category + ' )' : ''
          item.name = item.name + ' ' + item.category
        })
        this.loadingComponent.close()
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('Error While fetching product id ', errorMessage)
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    getKitListing: async function () {
      try {
        this.wowKitData = []
        this.loadingComponent = this.$buefy.loading.open()
        let filterData = {
          kitType: this.kit.id
        }
        if (this.selectedMappingObj.classID) {
          filterData.classID = Number(this.selectedMappingObj.classID)
        }
        if (this.academicYearID) {
          filterData.academicYear = this.academicYearID
        }
        console.log('filterData ', filterData)
        const response = await http.get(
          `${constants.API_URL}/api/kitSetMapping/get-kitSetMap-details`,
          {
            params: filterData
          }
        )

        if (response.data) {
          _.forEach(response.data, (item, index) => {
            this.wowKitData.push({
              id: item.id,
              kitName: item.kit.name,
              year: item.franchiseeAcademicYear.academicYear,
              class: item.studentClass.name,
              setName: item.name,
              status: item.status,
              reason: item.reason !== 'undefined' ? item.reason : '',
              productCount: item.productCount,
              isActive: item.isActive,
              regions: item.region,
              franchisees: item.franchisee.map(f => f.companyName).join(', '),
              isAssigned: item.isAssigned
            })
          })
          this.totalPages = response.data.totalPages
          this.totalItems = response.data.totalItems
          this.total = this.wowKitData.length
        } else {
          this.wowKitData = []
          this.total = 0
          this.paginated = false
        }
        this.loadingComponent.close()
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    resetAll: function () {
      this.selectedMappingObj.classID = ''
      this.getKitListing()
    },
    uploadProduct: function () {
      this.$router.push({ name: 'uploadKitMapping' })
    },
    handlePageSizeChange (size) {
      this.pageSize = size
      this.page = 1
      this.getKitListing()
    },
    handlePageChange (value) {
      this.page = value
      this.getKitListing()
      this.isLoading = true
    },
    deleteProductKitMapping (id) {
      let ref = this
      this.$dialog.warning({
        title: 'Delete Product Kit Mapping',
        text: 'Do you want to delete Product Kit Mapping?',
        actions: {
          false: {
            text: 'No'
          },
          true: {
            color: 'red',
            text: 'Yes',
            handle: async function () {
              try {
                ref.isLoading = true
                await http.delete(
                  `${constants.API_URL}/api/kits/product-map/${id}`
                )
                ref.isLoading = false
                ref.showRecord = true
                await ref.getKitListing()
                return ref.$dialog.info({
                  title: 'Success',
                  text: 'Product Kit Mapping deleted successfully!'
                })
              } catch (e) {
                console.log(e)
                ref.isLoading = false
                const errorMessage =
                  (e && e.response && e.response.data.message) || e.message
                console.log(
                  'error in deleting Product Kit Mapping  : ',
                  errorMessage
                )
                return ref.$dialog.error({
                  title: 'Error',
                  text: errorMessage
                })
              }
            }
          }
        }
      })
    },
    viewKitData: async function (id = '') {
      if (id) {
        try {
          this.kitSetProductData = []
          this.kitSetMapData = {
            id: '',
            kitName: '',
            class: '',
            setName: '',
            status: ''
          }
          this.previewKitData = false
          const response = await http.get(
            `${constants.API_URL}/api/kitSetMapping/get-kitSet-products/${id}`
          )
          if (response.status === 200) {
            this.previewKitData = true
            if (typeof response.data.kitSetMap !== 'undefined') {
              this.kitSetMapData.id = response.data.kitSetMap.id
              this.kitSetMapData.kitName = response.data.kitSetMap.kit.name
              this.kitSetMapData.class =
                response.data.kitSetMap.studentClass.name
              this.kitSetMapData.setName = response.data.kitSetMap.name
              if (
                response.data.kitSetMap.status === 'CH1_APPROVED' ||
                response.data.kitSetMap.status === 'REJECT' ||
                response.data.kitSetMap.status === 'APPROVED'
              ) {
                this.kitSetMapData.status = true
              } else {
                this.kitSetMapData.status = false
              }
            }
            this.kitSetProductData = response.data.kitSetProducts
          }
        } catch (e) {
          this.previewKitData = false
          const errorTitle =
            (e && e.response && e.response.data.error) || e.error
          const errorMessage =
            (e && e.response && e.response.data.message) || e.message
          return this.$dialog.error({
            title: errorTitle,
            text: errorMessage
          })
        }
      } else {
        this.previewKitData = false
      }
    },
    resetAddMoreKitDialogue: function () {
      this.dialogue = {
        fcid: '',
        quantity: '',
        isMandatory: 'No',
        alterFCID1: '',
        alterFCID2: ''
      }
      return true
    },
    addMoreKitData: async function (id = '') {
      if (id) {
        try {
          this.addKitDialogFlag = true
          let payload = {}
          if (this.dialogue.fcid === '' || this.dialogue.fcid <= 0) {
            return this.$dialog.error({
              title: 'Error with FCID',
              text: 'FCID should not be empty'
            })
          } else if (
            this.dialogue.quantity === '' ||
            this.dialogue.quantity <= 0
          ) {
            return this.$dialog.error({
              title: 'Error with Quantity',
              text: 'Quantity should not be empty and should be greater then 0.'
            })
          } else if (
            (this.dialogue.alterFCID1 === this.dialogue.fcid ||
              this.dialogue.alterFCID1 === this.dialogue.alterFCID2) &&
            this.dialogue.alterFCID1 !== ''
          ) {
            return this.$dialog.error({
              title: 'Error with Alternate FCID 1',
              text: 'Alternate FCID 1 not be equal to FCID or Alternate FCID 2'
            })
          } else if (
            (this.dialogue.alterFCID2 === this.dialogue.fcid ||
              this.dialogue.alterFCID2 === this.dialogue.alterFCID1) &&
            this.dialogue.alterFCID2 !== ''
          ) {
            return this.$dialog.error({
              title: 'Error with Alternate FCID 2',
              text: 'Alternate FCID 2 not be equal to FCID or Alternate FCID 1'
            })
          }
          payload.kitSetMapID = id
          payload.FCID = Number(this.dialogue.fcid)
          payload.quantity = Number(this.dialogue.quantity)
          payload.isMandatory = this.dialogue.isMandatory
          payload.alternateFCID1 =
            this.dialogue.alterFCID1 === ''
              ? 0
              : Number(this.dialogue.alterFCID1)
          payload.alternateFCID2 =
            this.dialogue.alterFCID2 === ''
              ? 0
              : Number(this.dialogue.alterFCID2)
          await http
            .post(
              `${constants.API_URL}/api/kitSetMapping/add-new-product`,
              payload
            )
            .then((res) => {
              if (res.status === 200) {
                this.viewKitData(id)
                this.resetAddMoreKitDialogue()
                this.addKitDialogFlag = false
                return this.$dialog.message.info(res.data.message, {
                  position: 'top-center',
                  color: 'success',
                  timeout: 4000
                })
              } else {
                return this.$dialog.message.info(res.data.message, {
                  position: 'top-center',
                  color: 'error',
                  timeout: 4000
                })
              }
            })
          await this.getKitListing()
        } catch (e) {
          const errorMessage =
            (e && e.response && e.response.data.message) || e.message
          this.$dialog.message.info(errorMessage, {
            position: 'top-center',
            color: 'error',
            timeout: 4000
          })
        }
      } else {
        this.addKitDialogFlag = false
      }
    },
    showReasonPrompt: function (reason) {
      return this.$dialog.error({
        title: 'Reason to reject the kit',
        text: reason
      })
    },
    editUploadKitMapping: function (id, count) {
      if (count > 0) {
        this.$router.push({
          name: 'editUplodKitMapping',
          params: { kitMapId: id }
        })
        return true
      } else {
        return false
      }
    },
    approvedByChecker: async function (type = '', kitMapId = 0) {
      if (type !== '' && kitMapId > 0) {
        try {
          let payload = {}
          payload.kitSetMapID = kitMapId
          payload.status = type === 'ch1' ? 'CH1_APPROVED' : 'APPROVED'
          await http
            .post(
              `${constants.API_URL}/api/kitSetMapping/update-status`,
              payload
            )
            .then((res) => {
              if (res.status === 200) {
                this.getKitListing()
                return this.$dialog.info({
                  title: 'Approved',
                  text: res.data
                })
              }
            })
        } catch (e) {
          const errorTitle =
            (e && e.response && e.response.data.error) || e.error
          const errorMessage =
            (e && e.response && e.response.data.message) || e.message
          return this.$dialog.error({
            title: errorTitle,
            text: errorMessage
          })
        }
      }
    },
    rejectKit: function (kitMapId = 0) {
      if (kitMapId > 0) {
        this.rejectKitSetMapId = kitMapId
        this.rejectCheckerFlag = true
      } else {
        this.rejectKitSetMapId = ''
        this.rejectCheckerFlag = false
      }
    },
    rejectByChecker: async function () {
      try {
        let payload = {}
        payload.kitSetMapID = this.rejectKitSetMapId
        payload.status = 'REJECT'
        payload.reason = this.rejectCheckerReason
        await http
          .post(`${constants.API_URL}/api/kitSetMapping/update-status`, payload)
          .then((res) => {
            if (res.status === 200) {
              this.rejectCheckerFlag = false
              return this.$dialog.info({
                title: 'Reject',
                text: res.data
              })
            } else {
              this.rejectCheckerFlag = true
            }
          })
      } catch (e) {
        const errorTitle = (e && e.response && e.response.data.error) || e.error
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        return this.$dialog.error({
          title: errorTitle,
          text: errorMessage
        })
      }
    },
    closeKitDialoguePopup: function () {
      this.resetAddMoreKitDialogue()
      this.addKitDialogFlag = false
    },
    restoreStatus: async function (item) {
      console.log('item ', item)
      try {
        const response = await http.post(
          `${constants.API_URL}/api/kitSetMapping/restore-status/${item.id}`
        )
        console.log('response 240 ', response)
        await this.getKitListing()
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        return this.$buefy.dialog.alert({
          message: `<div style="word-break:break-all;white-space:pre-line;">${errorMessage}</div>`,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true,
          customClass: 'no-scroll'
        })
      }
    },
    getAcademicYear: async function () {
      try {
        const response = await http.get(
          `${constants.API_URL}/api/franchiseeAcademicYears`
        )
        const data = response.data
        this.academicYears = data.rows

        const currentAcademicYear = Utils.getCurrentAcademicYear()
        let academicYear = this.academicYears.find((y) => {
          return y.academicYear.trim() === currentAcademicYear.trim()
        })
        this.academicYearID = academicYear ? academicYear.id : ''
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('Error While fetching Franchisee', errorMessage)
        this.lock = false
        this.hasClicked = false
        this.$dialog.notify.info(errorMessage, {
          position: 'top-right',
          color: 'error',
          timeout: 2000
        })
      }
    },
    openAssignDialog (item) {
      this.assigningKitItem = item
      this.showAssignDialog = true
    },
    cancelAssign () {
      this.showAssignDialog = false
      this.selectedSectionID = ''
      this.franchiseeID = ''
      this.resetAssignDialog()
      this.allFranchiseeChecked = false
    },
    getFranchisee: async function () {
      try {
        let zone = this.selectedSectionID
        const response = await http.post(`${constants.API_URL}/api/franchisee/get/zone-wise-franchisee`, {
          zone: zone
        })
        const data = response.data
        this.centerList = data
        this.classReports = []
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While fetching center data', errorMessage)
        this.lock = false
        this.hasClicked = false
        this.$dialog.notify.info(errorMessage, {
          position: 'top-right',
          color: 'error',
          timeout: 2000
        })
      } finally {
      }
    },
    getZoneDetails: async function () {
      try {
        this.isLoading = true
        let result = await http.get(`${constants.API_URL}/api/teacher-training/zone-options`)

        this.selectedZones = result.data
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    resetAssignDialog () {
      this.selectedSectionID = []
      this.franchiseeID = []
      this.zoneSearch = ''
      this.franchiseeSearch = ''
      this.showAssignDialog = false
    },
    handleZoneSelect () {
      this.getFranchisee()
      this.zoneSearch = ''
      this.franchiseeSearch = ''
    },
    async assignSampleKit () {
      const selectedFranchiseeIDs = this.franchiseeID.filter(id => id !== 'all')
      if (!selectedFranchiseeIDs.length || !this.selectedSectionID.length) {
        this.$dialog.error({ title: 'Error', text: 'Select both zone and franchisee.' })
        return
      }
      try {
        const payload = {
          kitSetMapID: this.assigningKitItem.id,
          franchiseeIDs: this.franchiseeID,
          zones: this.selectedSectionID
        }
        const res = await http.post(`${constants.API_URL}/api/kitSetMapping/assign-sample-kit`, payload)
        if (res.data.success && res.data.assignedKitMap) {
          this.$dialog.info({
            title: 'Assignment Successful',
            text: 'Assignment Successful'
          })
          this.showAssignDialog = false
          const kitId = this.assigningKitItem.id
          const idx = this.wowKitData.findIndex(k => k.id === kitId)
          if (idx !== -1) {
            this.$set(this.wowKitData, idx, {
              ...this.wowKitData[idx],
              isAssigned: true
            })
          }
          this.getKitListing()
        } else {
          this.$dialog.error({
            title: 'Error',
            text: 'Assignment Error.'
          })
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.$dialog.error({ title: 'Error', text: errorMessage })
      }
    },
    onZoneSelect () {
      this.$refs.zoneAutocomplete.blur()
      this.handleZoneSelect()
    },
    onFranchiseeSelect () {
      this.$refs.franchiseeAutocomplete.blur()
      this.franchiseeSearch = ''
      this.handleFranchiseeManualSelect()
    },
    toggleAllFranchisee () {
      if (this.allFranchiseeChecked) {
        this.franchiseeID = this.centerList.map(f => f.id)
      } else {
        this.franchiseeID = []
        this.getFranchisee()
        this.zoneSearch = ''
        this.franchiseeSearch = ''
      }
    },
    handleFranchiseeManualSelect () {
      if (
        this.franchiseeID.length !== this.centerList.length ||
      this.franchiseeID.length === 0
      ) {
        this.allFranchiseeChecked = false
      } else if (this.franchiseeID.length === this.centerList.length) {
        this.allFranchiseeChecked = true
      }
      this.franchiseeSearch = ''
      this.getFranchisee()
      this.zoneSearch = ''
    }
  }
}
</script>
<style>
.no-scroll .modal-card-body,
.no-scroll .modal-content {
  overflow-x: visible !important;
  word-break: break-word !important;
  white-space: pre-line !important;
  max-width: 90vw !important;
  max-height: 100vh !important;
  overflow-y: visible !important;
}
</style>
